<template>
  <v-text-field
    :class="{ 'error-input': hasError, focused: isFocused }"
    v-bind="$attrs"
    outlined
    dense
    :height="42"
    @focusin="isFocused = true"
    @focusout="isFocused = false"
    v-on="$listeners"
  />
</template>

<script>
export default {
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__slot {
  background: #fff !important;
}
.focused {
  ::v-deep .v-input__slot {
    color: #2536cc !important;
    box-shadow: 0px 0px 12px 4px #ebf2ff !important;
  }
}
.error-input {
  ::v-deep .v-input__slot {
    color: #ff5267 !important;
    box-shadow: 0px 0px 8px 2px #ffc6c6 !important;
  }
}
</style>
